// extracted by mini-css-extract-plugin
export default {"notification":"error-component_notification__Ix7G2"};